import { defineStore } from 'pinia'
import { api } from '@/api/axios'
import { getToken } from '@/utils/tokenStorage'

export const useFacturasStore = defineStore('facturas', {
  state: () => ({
    facturas: [],
    search: '',
    perPage: 20,
    page: 1,
    currentPage: 1,
    totalFacturas: 0,
    totalPages: 1
  }),
  actions: {
    async fetchFacturas({ page, rows, search, perPage, fecha = null } = {}) {
      console.log('fecha', fecha)
      try {
        const response = await api.get('/facturas', {
          headers: {
            Authorization: `Bearer ${getToken()}`
          },
          params: {
            page: page || this.page,
            rows: rows || this.rows,
            search: search || this.search,
            per_page: perPage || this.perPage,
            fecha: fecha || null
          }
        })
        this.facturas = response.data.items
        this.totalFacturas = response.data.total
        this.totalPages = response.data.pages
        this.perPage = response.data.per_page
        this.page = response.data.page
        return this.facturas
      } catch (error) {
        console.error('Error al obtener facturas:', error)
        throw error
      }
    },
    async createFactura(factura) {
      try {
        const response = await api.post('/facturas', factura, {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        })
        this.facturas.push(response.data)
        return response.data
      } catch (error) {
        console.error('Error al crear factura:', error)
        throw error
      }
    },
    async updateFactura(factura) {
      try {
        const response = await api.put(`/facturas/${factura.id}`, factura, {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        })
        const index = this.facturas.findIndex((f) => f.id === factura.id)
        if (index !== -1) {
          this.facturas[index] = response.data
        }
        return response.data
      } catch (error) {
        console.error('Error al actualizar factura:', error)
        throw error
      }
    },
    async deleteFactura(id) {
      try {
        await api.delete(`/facturas/${id}`, {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        })
        this.facturas = this.facturas.filter((f) => f.id !== id)
      } catch (error) {
        console.error('Error al eliminar factura:', error)
        throw error
      }
    },
    setSearch(search) {
      this.search = search
    },
    setRows(rows) {
      this.rows = rows
    },
    setPage(page) {
      this.page = page
    },
    async getFactura(id) {
      try {
        if (!id) {
          id = 0
        }
        const response = await api.get(`/facturas/${id}`, {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        })
        return response.data
      } catch (error) {
        console.error('Error al obtener factura:', error)
        throw error
      }
    }
  }
})
